import { Card, CardHeader } from "@/components/ui/card";
import { Avatar } from "@/components/catalyst/avatar";
import { getInitials } from "@/lib/Utils/getInitials";
import { UserFieldsFragment } from "@/gql/graphql";
import { CopyToClipboard } from "@/lib/Components/Common/CopyToClipboard";

export function WaitlistUserCard({ user }: { user: UserFieldsFragment }) {
  return (
    <Card className="w-full">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-4">
          <Avatar
            className="size-16 border-2 border-gray-200 bg-white shadow-sm"
            media={user.profilePicture}
            initials={getInitials(user.name ?? "")}
          />
          <div className="min-w-0 flex-1">
            <h3 className="truncate font-semibold text-gray-900">
              {user.name || "Unknown User"}
            </h3>
            <div className="space-y-1 text-sm text-gray-600">
              {user.primary_email && (
                <div className="truncate">
                  <CopyToClipboard text={user.primary_email} />
                </div>
              )}
              {user.primary_phone && (
                <div>
                  <CopyToClipboard text={user.primary_phone} />
                </div>
              )}
            </div>
          </div>
        </div>
      </CardHeader>
    </Card>
  );
}
